import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "gfu-product-set-items _cf" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-product-card__tag-container _ml-3"
}
const _hoisted_3 = { class: "gfu-product-set-item gfu-media" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-thumb"
}
const _hoisted_5 = ["url"]
const _hoisted_6 = ["data-qa"]
const _hoisted_7 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_image = _resolveComponent("base-image")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedSetItems, (setItem) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `set-item-${setItem.productID}`,
        class: "gfu-product-set-items__item gfu-1of2--m gfu-1of1"
      }, [
        (setItem.isDigital)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_base_badge, { "data-qa": "product-details:DigitalBadge" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.DigitalProductBadge), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          (setItem.hasFullDescription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                ($options.isModal)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: $options.route(setItem.productID)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_image, {
                          src: setItem.productImageUrl,
                          alt: setItem.name,
                          width: "48",
                          height: "48",
                          loading: "lazy"
                        }, null, 8 /* PROPS */, ["src", "alt"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      url: setItem.productDetailsUrl
                    }, [
                      _createVNode(_component_base_image, {
                        src: setItem.productImageUrl,
                        alt: setItem.name,
                        width: "48",
                        height: "48",
                        loading: "lazy"
                      }, null, 8 /* PROPS */, ["src", "alt"])
                    ], 8 /* PROPS */, _hoisted_5))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: "gfu-media__body",
            "data-qa": `reward-item-id:${setItem.productID}`
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['gfu-product-set-item__name gfu-hd gfu-hd--h4 gfu-hd--decorative', { '_pl-2': setItem.hasFullDescription }])
            }, [
              (setItem.hasFullDescription)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    ($options.isModal)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: $options.route(setItem.productID),
                          "data-qa": "reward-item:Name"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(setItem.name), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: setItem.productDetailsUrl,
                          "data-qa": "reward-item:Name"
                        }, _toDisplayString(setItem.name), 9 /* TEXT, PROPS */, _hoisted_7))
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(setItem.name), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(['_tc--lighter gfu-bt--caption', { '_pl-2': setItem.hasFullDescription }]),
              "data-qa": "reward-item:Quantity"
            }, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Product.RewardCardProductSetItemQuantityLabel, setItem.quantity)), 3 /* TEXT, CLASS */)
          ], 8 /* PROPS */, _hoisted_6)
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}